import { inspect } from 'util'

import {
    isAndroid,
    isChrome,
    isIOS,
    isMacOs,
    isMobile,
    isMobileOnly,
    isMobileSafari,
    isSafari,
    isTablet,
    deviceDetect,
} from 'react-device-detect'
import { isSupported } from 'twilio-video'

import { isNil } from 'helpers/lodash'
import { userTypes } from 'helpers/user'

export const deviceDetails = inspect(deviceDetect())

export const isIPad =
    (isTablet && (isIOS || isMacOs)) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0)

export const isIPhone = isIOS && isMobileOnly

export const isDesktop = !isMobile && !isTablet

export const isMobilePhone = !isDesktop && !isTablet

export const isMobileOrIPad = isMobileOnly || isIPad

export const isAndroidTablet = isTablet && isAndroid

export const isSafariMobileOrDesktop = isSafari || isMobileSafari

export const isValidDevice = async userType => {
    if (!userType) return false

    let res = false
    if (userType.toLowerCase() === userTypes.TEACHER) {
        res = isDesktop
    } else if (userType.toLowerCase() === userTypes.STUDENT) {
        res = true
    }

    return res
}

export const isValidBrowser = async () => {
    if (!isSupported) return false

    if (isDesktop && isChrome) return true

    if (!isDesktop) {
        if (isAndroid && isChrome) return true
        if (isIOS && (isSafari || isMobileSafari)) return true
    }

    return false
}

export const deviceAVDetails = async () => {
    const devices = await navigator.mediaDevices.enumerateDevices()
    const videoInputs = devices.filter(device => device.kind === 'videoinput')
    const audioInputs = devices.filter(device => device.kind === 'audioinput')
    const audioOutputs = devices.filter(device => device.kind === 'audiooutput')
    const hasWebcam = videoInputs.length > 0
    const hasMicrophone = audioInputs.length > 0
    const hasSpeakers = audioOutputs.length > 0
    const shouldAskForPermissions = devices.every(
        device => !(device.deviceId && device.label)
    )

    let details = {
        hasWebcam,
        hasMicrophone,
        hasSpeakers,
        shouldAskForPermissions,
        hasBlockedOrResetAudio: false,
        hasBlockedOrResetVideo: false,
    }

    if (shouldAskForPermissions) return details

    /* 
       when user manually blocks or resets audio/video shouldAskForPermissions is false 
       so as a double check when permission is blocked/reset we add the hasBlockedOrResetAudio 
       or hasBlockedOrResetVideo key to the details
    */
    const deviceWOLabelAndId = devices.find(
        device => !(device.deviceId && device.label)
    )

    if (!isNil(deviceWOLabelAndId)) {
        details.hasBlockedOrResetAudio =
            deviceWOLabelAndId.kind === 'audioinput'
        details.hasBlockedOrResetVideo =
            deviceWOLabelAndId.kind === 'videoinput'
    }

    return details
}
